










































import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "DialogUniversal",
  props: {
    handleDismissDialog: {
      type: Function,
      required: false
    }
  },
  computed: {
    ...mapGetters(["GET_DIALOG_STATUS"]),

    submitFn(): Function | null {
      return this.GET_DIALOG_STATUS.submitFn || null;
    },
    displayTitle(): string {
      return this.localize(this.GET_DIALOG_STATUS.title);
    },
    displayMessage(): string {
      return this.localize(this.GET_DIALOG_STATUS.message);
    },
    displaySubmitLabel(): string {
      return this.localize(this.GET_DIALOG_STATUS.submitLabel);
    },
    displayCloseLabel(): string {
      return this.localize(
        this.GET_DIALOG_STATUS.closeLabel || "dialog.generic.btn-close"
      );
    }
  },
  methods: {
    // Accepts either an i18n key or a raw string, so the dialog is reusable
    // for both localized copy and dynamic (e.g. backend) messages.
    localize(value?: string): string {
      if (!value) return "";
      return this.$te(value) ? (this.$t(value) as string) : value;
    },

    handleSubmit(): void {
      if (this.submitFn) this.submitFn();
    }
  }
});
